import TileDebugClass, * as TileDebugModule from './../../node_modules/ol/source/TileDebug.js';

class TileDebug extends TileDebugClass {
    constructor(options = {}) {
        options = options || {}
        super(options);
    }
}

// Copy all named exports as static methods
for (const key in TileDebugModule) {
    if (key !== "default") {
        TileDebug[key] = TileDebugModule[key];
    }
}

export default TileDebug;

// Re-export ALL named exports from OL
export * from './../../node_modules/ol/source/TileDebug.js';